import { render } from "./SuccessSess.vue?vue&type=template&id=4438a068&scoped=true"
import script from "./SuccessSess.vue?vue&type=script&lang=js"
export * from "./SuccessSess.vue?vue&type=script&lang=js"

import "./SuccessSess.vue?vue&type=style&index=0&id=4438a068&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4438a068"]])

export default __exports__